import { BaseModel } from '../../base.model';

export class VerificationOfExperienceRequestDto extends BaseModel {
  responseDueDate: Date;
  reason: string;
  hrRef: number;
}
